	<template>
	<div>
		<form>
			<v-layout wrap px-4 py-5>
				<v-flex xs12 pb-2 v-if="!isEdit">
					<BaseInput
						:height="38"
						label="Código"
						required
						disabled
						v-model="model.code"
					>
						<span slot="error" class="caption error--text" v-if="$v.model.code.$invalid">
							El código es requerido
						</span>
					</BaseInput>
				</v-flex>
				<v-flex xs12 pb-2>
					<BaseInput
						:height="38"
						label="Nombre"
						required
						v-model="model.name"
					>
						<span slot="error" class="caption error--text" v-if="$v.model.name.$invalid">
							El nombre es requerido
						</span>
					</BaseInput>
				</v-flex>
				<v-flex xs12 pb-2>
					<BaseSelect
						autocomplete
						return-object
						item-text="fullName"
						item-value="account"
						label="Cuenta Contable"
						:height="38"
						:items="accounts"
						:value="newAccount"
						@input="setData($event, 'account')"
					/>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					@cancel-button-clicked="$emit('on-close')"
					@accept-button-clicked="submitForm"
					:is-loading="disabled"
				></modal-sidebar-button>
			</section>
		</form>
	</div>
</template>

<script>
	import { required } from 'vuelidate/lib/validators';

	function mounted() {
		this.model.subsidiaryId = this.$route.query.subsidiaryId;
		this.loadCostsCenters();
		this.loadAccounts();
		if (this.fatherId) {
			this.model.costCenterId = this.fatherId;
		}
		this.model.code = this.code;
	}

	function disabled() {
		return this.$v.$invalid || this.loading;
	}

	async function loadAccounts() {
		this.loading = true;
		const { subsidiaryId } = this.$route.query;
		const params = { status: 1 };
		const url = `accounting-plan/${subsidiaryId}/subsidiary`;
		try {
			({ data: this.accounts } = await this.$http.get(url, { params }));
			if (this.id) {
				this.newAccount = this.accounts[0].account;
				this.setData(this.accounts[0], 'account');
			}
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	async function loadCostCenter() {
		this.loading = true;
		const { data: response } = await this.$http.get(`cost-center/${this.id}`);
		this.model = {
			account: response.accountingAccount,
			code: response.code,
			costCenterId: response.costCenterId,
			name: response.name,
			subsidiaryId: response.subsidiaryId,
		};
		if (this.model.costCenterId) {
			this.model.costCenter = response.costCenter;
		}
		this.loading = false;
	}

	async function loadCostsCenters() {
		this.loading = true;
		const { subsidiaryId } = this.$route.query;
		({ data: this.costsCenters } = await this.$http.get(
			`cost-center/${subsidiaryId}/subsidiary`));
		if (this.id) {
			this.loadCostCenter();
		}
		this.loading = false;
	}

	function setData(val, model) {
		this.newAccount = val.account;
		this.model[model] = val;
	}

	async function submitForm() {
		this.loading = true;
		const { subsidiaryId } = this.$route.query;
		const method = this.id ? 'patch' : 'post';
		const url = this.id ? `cost-center/${this.id}/${subsidiaryId}` : 'cost-center';
		const action = this.id ? 'editó' : 'creó';
		const body = {
			account: this.model.account ? this.model.account.code : null,
			accountingAccount: this.model.account,
			code: this.model.code,
			costCenterId: this.model.costCenterId,
			name: this.model.name,
			level: Number(this.level),
		};
		if (!this.id) {
			body.subsidiaryId = Number(this.model.subsidiaryId);
		}
		try {
			await this.$http[method](url, body);
			this.showNotification(`Se ${action} correctamente.`);
			this.$emit('on-close');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			} else if (err.status === 400) {
				if (err.data.message === 'COST_CENTER_CODE_REPEATED') {
					this.showGenericError('No se pueden crear centros de costos con códigos ya registrados.');
				}
			}
		} finally {
			this.loading = false;
		}
	}

	function validations() {
		return {
			model: {
				code: { required },
				name: { required },
				subsidiaryId: { required },
			},
		};
	}

	function data() {
		return {
			accounts: [],
			costsCenters: [],
			model: {
				account: null,
				code: null,
				costCenterId: null,
				name: null,
				subsidiaryId: null,
			},
			newAccount: null,
		};
	}

	export default {
		name: 'cost-center-form',
		components: {
			BaseInput: () => import('@/components/shared/inputs/base-input'),
			BaseSelect: () => import('@/components/shared/inputs/base-select'),
		},
		computed: {
			disabled,
		},
		data,
		methods: {
			loadAccounts,
			loadCostCenter,
			loadCostsCenters,
			setData,
			submitForm,
		},
		mounted,
		props: {
			id: [Number, String],
			fatherId: {
				type: Number,
				default: () => null,
			},
			isEdit: {
				type: Boolean,
				default: false,
			},
			code: {
				type: String,
				default: '',
			},
			level: {
				type: Number,
				default: 1,
			},
		},
		validations,
	};
</script>



// WEBPACK FOOTER //
// src/components/cost-centers/cost-center-form.vue